addEventListener('turbo:before-cache', () => {
	const poppers = document.querySelectorAll("[data-popper-target='popperElement']:not(.d-none)")
	for (const popper of poppers) {
		popper.classList.add('d-none')
	}
})
